import { z } from 'zod';

// ====================================================================
// Skema untuk Validasi Form Pembuatan Pengguna
// ====================================================================

/**
 * Skema Zod untuk memvalidasi data dari formulir pembuatan pengguna baru.
 * Didasarkan secara akurat pada body request POST /v4/user.
 * Skema ini akan digunakan oleh react-hook-form untuk validasi di sisi klien.
 */
export const CreateUserV4Schema = z.object({
    /**
     * ID Perusahaan. Diambil dari data pengguna yang sedang login.
     * Divalidasi sebagai UUID untuk memastikan formatnya benar.
     */
    company_id: z.union([z.string().uuid(), z.literal('')]).optional().nullable(),

    /**
     * Nama lengkap pengguna.
     * Wajib diisi (nonempty).
     */
    name: z.string().nonempty({ message: "Name is required." }),

    /**
     * Nomor telepon pengguna.
     * Wajib diisi.
     */
    phone: z.string().nonempty({ message: "Phone number is required." }),

    /**
     * Alamat email pengguna.
     * Wajib diisi dan harus dalam format email yang valid.
     */
    email: z.string().nonempty({ message: "Email is required." }).email({ message: "Invalid email address." }),

    /**
     * Password untuk pengguna baru.
     * Wajib diisi dan harus memiliki minimal 8 karakter.
     */
    password: z.string().min(8, { message: "Password must be at least 8 characters long." }),
});


// ====================================================================
// Tipe TypeScript yang Diekspor
// ====================================================================

/**
 * Tipe TypeScript untuk data formulir pembuatan pengguna,
 * diturunkan secara otomatis dari skema Zod.
 * Tipe ini akan digunakan di dalam komponen form untuk type safety.
 */
export type CreateUserFormData = z.infer<typeof CreateUserV4Schema>;